/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Button } from "@components/anti/Button"
import { Card } from "@components/anti/Card"
import Input from "@components/anti/Forms/components/input"
import Select from "@components/anti/Forms/components/select"
import CardList from "@components/global/CardList"
import { getListJobs } from "lib/api"
import { linkCareers } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function CareerLandingList({ data, locale, listJobLocations }) {
  // ============================ STATES ============================ //
  const router = useRouter()
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  const [state, setState] = useState({
    position: "",
    loading: false,
    list: data?.list,
    pagination: data?.pagination,
    listLocation: [],
    locationId: { label: translations[`all_location_${locale}`], value: 0 },
    listType: [
      {
        label: translations[`all_employment_type_${locale}`],
        value: "ALL",
      },
      {
        label: translations[`full_time_${locale}`],
        value: "FULLTIME",
      },
    ],
    type: {
      label: translations[`all_employment_type_${locale}`],
      value: "ALL",
    },
  })
  const { list, pagination } = state
  // ============================ STATES ============================ //
  // ============================ FUNCTION ============================ //
  const handleChangeState = (value) =>
    setState((prev) => ({ ...prev, ...value }))
  const onClickLoadMore = async () => {
    try {
      const { type, locationId, position } = state
      const variables = {
        type: type.value,
        location_id: locationId.value,
        position,
        first: 12,
        page: pagination.currentPage + 1,
      }
      if (type.value === "ALL") delete variables.type
      if (locationId.value === 0) delete variables.location_id
      if (!position) delete variables.position
      const jobsUpdate = await getListJobs({
        ...variables,
      })
      setState((prev) => ({
        ...prev,
        list: [...state.list, ...jobsUpdate.data],
        pagination: jobsUpdate.paginatorInfo,
      }))
      return jobsUpdate
    } catch (error) {
      return { notFound: true }
    }
  }
  const handleFetchJobs = async (variables) => {
    handleChangeState({ loading: true })
    try {
      const jobsUpdate = await getListJobs({ ...variables })
      handleChangeState({
        list: jobsUpdate.data,
        pagination: jobsUpdate.paginatorInfo,
      })
    } catch (error) {
      // need error handle
      // eslint-disable-next-line no-console
      console.error("error ===>", error)
    } finally {
      handleChangeState({ loading: false })
    }
  }
  const onSearch = (query) => {
    const queryFinal = { ...query }
    Object.keys(query).forEach((item) => {
      if (!query[item]) delete queryFinal[item]
    })
    router.push(
      {
        pathname: linkCareers,
        query: { ...queryFinal },
      },
      null,
      { scroll: false }
    )
  }
  // ============================ FUNCTION ============================ //
  // ============================ REACT OPS ============================ //
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      locationId: { label: translations[`all_location_${locale}`], value: 0 },
      type: {
        label: translations[`all_employment_type_${locale}`],
        value: "ALL",
      },
      listLocation: [
        { label: translations[`all_location_${locale}`], value: 0 },
        ...listJobLocations.map((item) => ({
          label: item.name,
          value: item.id,
        })),
      ],
    }))
  }, [locale, data, listJobLocations])
  useEffect(() => {
    const { type, locationId, position } = router.query
    const variables = {
      type,
      location_id: +locationId,
      position,
      first: 12,
      page: 1,
    }
    const findLocation = listJobLocations.find(
      (item) => item.id === +locationId
    ) || { name: translations[`all_location_${locale}`], id: 0 }
    const findType = type
      ? state.listType.find((item) => item.value === type)
      : state?.listType[0]
    handleChangeState({
      type: { ...findType },
      locationId: { label: findLocation.name, value: findLocation.id },
      position: position || "",
    })
    Object.keys(variables).forEach((item) => {
      if (!variables[item]) delete variables[item]
      if (variables?.type === "ALL") delete variables.type
    })
    handleFetchJobs(variables)
  }, [router])
  // ============================ REACT OPS ============================ //
  return (
    <section className="sc-career-landing-list" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <h1 className={`title ${anim(1)}`}>
            {data && data[`title_${locale}`]}
          </h1>
          <div className={`text ${anim(2)}`}>
            {convertHtmlToReact(data[`description_${locale}`])}
          </div>
          <div className={`warning ${anim(3, "fadeInUp7")}`}>
            {convertHtmlToReact(data[`warning_fraud_${locale}`])}
          </div>
          <div className={`career-list__search-wrapper ${anim(3)}`}>
            <div className="row">
              <div className="col-md-3">
                <Select
                  label={translations[`employment_type_${locale}`]}
                  floatingLabel
                  variant="underline"
                  value={state.type}
                  options={state.listType}
                  // onChange={(_, value) => handleChangeState({ type: value })}
                  onChange={(_, value) =>
                    onSearch({
                      type: value.value,
                      locationId: state.locationId.value,
                      position: state.position,
                    })
                  }
                />
              </div>
              <div className="col-md-3">
                <Select
                  label={translations[`location_${locale}`]}
                  floatingLabel
                  variant="underline"
                  value={state.locationId}
                  options={state.listLocation}
                  onChange={(_, value) => {
                    onSearch({
                      locationId: value.value,
                      type: state.type.value,
                      position: state.position,
                    })
                  }}
                  // onChange={(_, value) =>
                  //   handleChangeState({ locationId: value })
                  // }
                />
              </div>
              <div className="col-md-5">
                <Input
                  variant="underline"
                  value={state.position}
                  placeholder={
                    translations[`search_position_placeholder_${locale}`]
                  }
                  onChange={(e) => {
                    handleChangeState({ position: e.target.value })
                    if (!e.target.value) {
                      onSearch({
                        position: "",
                        locationId: state.locationId.value,
                        type: state.type.value,
                      })
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onSearch({
                        position: e.target.value,
                        locationId: state.locationId.value,
                        type: state.type.value,
                      })
                    }
                  }}
                />
              </div>
              <div className="col-md-1">
                <Button
                  variant="outline-primary"
                  iconLeft="air ai-search"
                  // onClick={() => onClickSearch()}
                  onClick={() =>
                    onSearch({
                      position: state.position,
                      locationId: state.locationId,
                      type: state.type,
                    })
                  }
                  className={state.loading ? "loading" : ""}
                >
                  {translations[`search_${locale}`]}
                </Button>
              </div>
            </div>
          </div>
          <CardList
            data={list}
            className="career-list"
            onClickLoadMore={onClickLoadMore}
            hasMore={pagination.hasMorePages}
            notFoundTitle={translations[`not_found_jobs_title_${locale}`]}
            notFoundText={translations[`not_found_jobs_text_${locale}`]}
            grid="col-sm-6 col-lg-3"
            render={(item, i) => (
              <Card
                variant="overlay"
                img="/img/bg/img_bg-card.png"
                className="mb-3 career-list__item"
                imgRatio="r-4-3"
                label={item.type}
                title={item[`title_${locale}`]}
                text={
                  <>
                    <i className="ais ai-map-marker-alt mr-2" />{" "}
                    {item?.location?.name}
                  </>
                }
                textClassName="text-muted"
                link={`${linkCareers}/${item.slug}`}
                withAnim
                index={i}
              />
            )}
          />
        </div>
      </div>
    </section>
  )
}

export default CareerLandingList
